import * as React from 'react';
import * as ReactDOM from 'react-dom';

export interface Dictionary<T> {
  [key: string]: T;
}

/**
 * @returns the measured width of a component or element, rounded up to the nearest integer.
 * Returns -1 if the provided node is null, unmounted, or text.
 */
export function measureWidth(componentOrElement: React.Component | Element): number {
  try {
    const domNode = ReactDOM.findDOMNode(componentOrElement);
    if (domNode instanceof Element) {
      const rect = domNode.getBoundingClientRect();
      return Math.ceil(rect.right - rect.left);
    } else {
      return -1;
    }
  } catch (e) {
    return -1;
  }
}

export function measureScrollbarWidth(div: HTMLElement): number {
  const value = div.style.overflowY;
  div.style.overflowY = 'scroll';
  const scrollbarWidth = div.offsetWidth - div.clientWidth;
  div.style.overflowY = value;
  return scrollbarWidth;
}

export function assert(condition: boolean, message: string): void {
  if (!condition) {
    throw new Error(message);
  }
}

/**
 * Returns value bound within [min, max]
 */
export function clamp(value: number, min: number, max: number): number {
  if (max < min) { console.error('clamp called with max < min'); }
  if (value < min) { return min; }
  if (value > max) { return max; }
  return value;
}

const isMac = /Mac/.test(navigator.userAgent);

/**
 * Platform-aware version of `e.ctrlKey`
 */
export function isCtrl(event: MouseEvent | React.KeyboardEvent | React.MouseEvent | React.TouchEvent) {
  if (isMac) {
    return event.metaKey || event.ctrlKey;
  } else {
    return event.ctrlKey;
  }
}

export function isFocusable(element: HTMLElement): boolean {
  if (!element) { return false; }
  return !isNaN(parseInt(element.getAttribute('tabindex')!, 10)) ||
    ['INPUT', 'SELECT', 'TEXTAREA', 'BUTTON'].indexOf(element.tagName) >= 0 ||
    (element.tagName === 'A' && !!element.getAttribute('href'));
}
